import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SwiperOptions } from 'swiper/types';
import { SwiperComponent } from 'swiper/angular';
import { Sliders } from 'src/app/models/sliders.model';
import { SlidersService } from 'src/app/services/sliders.service';
import { environment } from 'src/environments/environment.prod';

@Component({
	selector: 'app-hometwo-main-banner',
	templateUrl: './hometwo-main-banner.component.html',
})
export class HometwoMainBannerComponent implements OnInit {
	@ViewChild('swiper') swiper?: SwiperComponent;

	sliders: Sliders[] = [];

	homeSlides: SwiperOptions = {
		loop: true,
		pagination: {
			clickable: true,
		},
		navigation: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		effect: 'fade',
		slidesPerView: 1
	}

	constructor(public service: SlidersService, private sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		this.service.getAll$().subscribe(x => {
			this.sliders = x ?? [];
		});
	}

	/**
	 * Returns a safe background-image style object for [ngStyle].
	 * Using [ngStyle] instead of [style.background-image] is more reliable
	 * with Angular's security sanitizer for dynamic URLs.
	 */
	getSliderStyle(img1?: string): SafeStyle | string {
		if (img1) {
			// Normalise path: remove any leading slash to avoid double-slash
			const cleanPath = img1.startsWith('/') ? img1.slice(1) : img1;
			const url = `${environment.patchUrl}/${cleanPath}`;
			return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
		}
		return '';
	}
}
